if (!customElements.get('card-product-form')) {
  class CardProductForm extends ProductSelector {
    constructor() {
      super();

      this.accordion = this.querySelector('accordion-element');
      this.details = this.accordion?.querySelector('details');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      document.addEventListener('cart-drawer:add', () => {
        this.accordion?.close(this.details);
      });
    }
  }

  customElements.define('card-product-form', CardProductForm);
}
